var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.srcIsCanvas)?_c('canvas',{ref:"canvas"}):_c('img',{attrs:{"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }